import axios from '../axios-config';

const getProductReviews = async (sku) => {
  const config = {
    method: 'get',
    url: `/reviews.json?key=${sku}`,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getMultiProductsRating = async (ids) => {
  const data = { product_ids: ids };
  const config = {
    method: 'post',
    url: `/product/reviews/rating`,
    data: JSON.stringify(data),
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductReviewsV2 = async (id, locale) => {
  const config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/product/reviews/${locale}/${id}`,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};
export { getProductReviews, getMultiProductsRating, getProductReviewsV2 };
